"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireDefault(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _reactSlick = _interopRequireDefault(require("react-slick"));
var _slider = _interopRequireDefault(require("./slider.css"));
var Slider = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inheritsLoose2["default"])(Slider, _React$PureComponent);
  function Slider() {
    return _React$PureComponent.apply(this, arguments) || this;
  }
  var _proto = Slider.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      children = _this$props.children,
      className = _this$props.className,
      forwardedRef = _this$props.forwardedRef,
      settings = _this$props.settings;
    return /*#__PURE__*/_react["default"].createElement(_reactSlick["default"], (0, _extends2["default"])({
      ref: forwardedRef,
      className: (0, _clsx["default"])(_slider["default"].slider, className)
    }, settings), children);
  };
  return Slider;
}(_react["default"].PureComponent);
Slider.displayName = 'Slider';
Slider.defaultProps = {
  settings: {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1.2
  }
};
var _default = Slider;
exports["default"] = _default;